
  import { Vue, Component, Prop } from 'vue-property-decorator';
  import { Field, DropdownField } from '@samc/centricity-core';
  import { TrusteeSource } from '@/Sources';

  @Component({
    name: 'trustee-dropdown-field',
    components: { Field, DropdownField }
  })
  export default class TrusteeDropdownField extends Vue {
    @Prop() public value!: string;
    @Prop({ default: 'Trustee' }) public label!: string;
    @Prop({ type: Boolean, default: false }) public disabled!: boolean;
    @Prop({ type: Boolean, default: false }) public autoAssign!: boolean;
    @Prop() public placeholder!: string;
    @Prop({ default: '' }) public errorText!: string;

    public source: TrusteeSource = new TrusteeSource(true);

    public get val(): string { return this.value; }
    public set val(value: string) {
      this.$emit('input', value);
    }
  }
